export type ContextCompactionUiState = {
	status: "compacting" | "ready" | "failed";
	updatedAt: number;
	boundaries?: ReadonlyArray<{ completedAt: number }>;
};

export type ContextCompactionMarkerSpec = {
	index: number;
	status: "compacting" | "ready";
	key: string;
};

const COMPACTION_MARKER_STALE_MS = 5 * 60 * 1000;

/** Marker positions for a transcript, given each item's creation timestamp. */
export function contextCompactionMarkers(
	itemTimestamps: ReadonlyArray<number | undefined>,
	compaction?: ContextCompactionUiState,
	now = Date.now(),
): ContextCompactionMarkerSpec[] {
	if (!compaction || compaction.status === "failed") return [];
	const completedAt =
		compaction.boundaries && compaction.boundaries.length > 0
			? compaction.boundaries.map((boundary) => boundary.completedAt)
			: compaction.status === "ready"
				? [compaction.updatedAt]
				: [];
	const markers: ContextCompactionMarkerSpec[] = completedAt.map(
		(timestamp) => {
			const firstLaterItem = itemTimestamps.findIndex(
				(itemTime) => typeof itemTime === "number" && itemTime > timestamp,
			);
			return {
				index: firstLaterItem === -1 ? itemTimestamps.length : firstLaterItem,
				status: "ready" as const,
				key: `ready:${timestamp}`,
			};
		},
	);
	if (
		compaction.status === "compacting" &&
		now - compaction.updatedAt <= COMPACTION_MARKER_STALE_MS
	) {
		markers.push({
			index: itemTimestamps.length,
			status: "compacting",
			key: `compacting:${compaction.updatedAt}`,
		});
	}
	return markers;
}
